import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { ResponseStatusCodes } from '@common/types';
import { getTermStatus } from '@services/apis/insure/term';

import { TermPolicyStatusResponse } from './types';

type State = {
  policy: TermPolicyStatusResponse['data'] | null;
  loading: boolean;
  error: string | null;
  errorResponseStatusCode: number | null;
};

type Action = {
  fetchStatus: (policyId?: string) => Promise<void>;
};

export const useTermStatus = create<State & Action>()(
  immer(
    devtools((set, get) => ({
      policy: null,
      loading: false,
      error: null,
      errorResponseStatusCode: null,
      fetchStatus: async (policyId?: string) => {
        try {
          if (!policyId) {
            set((state) => {
              state.loading = false;
              state.error = 'Policy ID is required.';
            });
            return;
          }

          if (get().loading) {
            return;
          }

          set((state) => {
            state.errorResponseStatusCode = null;
            state.loading = true;
            state.error = null;
          });
          const status = await getTermStatus(policyId);
          if (status) {
            const { data } = status;

            set((state) => {
              state.policy = { ...data };
              state.loading = false;
            });
          }
        } catch (err: any) {
          set((state) => {
            state.loading = false;

            if (err?.response?.status === ResponseStatusCodes.FORBIDDEN) {
              return;
            }
            state.error =
              err?.message || 'Something went wrong. Please try again later.';
            state.errorResponseStatusCode = err?.response?.status;
          });
        }
      }
    }))
  )
);
